import { render, staticRenderFns } from "./SurveyDialog.vue?vue&type=template&id=58f7c877"
import script from "./SurveyDialog.vue?vue&type=script&lang=js"
export * from "./SurveyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f7c877')) {
      api.createRecord('58f7c877', component.options)
    } else {
      api.reload('58f7c877', component.options)
    }
    module.hot.accept("./SurveyDialog.vue?vue&type=template&id=58f7c877", function () {
      api.rerender('58f7c877', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/SurveyDialog.vue"
export default component.exports